// NewsletterList.jsx
import React, { useEffect, useState } from "react";
import { useAuth } from "../../auth/AuthContext.jsx";


import { useNavigate } from "react-router-dom";
import SendEmailModal from "../common/SendEmailModal.jsx";

import UtilMethods from "../../util/UtilMethods.jsx";

import MarianLogo from "../common/MarianLogo.jsx"; // Import the MarianLogo component

import { Modal, Button, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  FaEdit,
  FaTrash,
  FaEnvelope,
  FaRegEnvelopeOpen,
  FaInbox,
  FaSave,
  FaTimes,
  FaCheckCircle,
} from "react-icons/fa"; // Import the desired icons

import { sendEmail, sendEmailNewsLetters } from "../../services/EmailSender.js";
import { TextWrap } from "react-bootstrap-icons";

import { listNewsletters } from "../../services/AdminServices.js";

export default function ListNewslettersPage() {
  const unsubscribeURL = `${process.env.REACT_APP_URL}/unsubscribeNews?email=`;
  const [newsletters, setNewsletters] = useState([]);
  const { user, logout } = useAuth();
  const [filters, setFilters] = useState({
    date: "",
    id: "",
    status: "",
    region: "",
    category: "",
  });
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailInput, setEmailInput] = useState("");
  const [selectedNewsletterId, setSelectedNewsletterId] = useState(null);
  const [emailMode, setEmailMode] = useState("emailjs"); // "emailjs" or "sendgrid"
  const [editingId, setEditingId] = useState(null);
  const [editRow, setEditRow] = useState({});


  const onList = async () => {
    console.log("Listing newsletters with filters:", filters);
    const data = await listNewsletters(filters);
    console.log("Fetched newsletters:", data);
    setNewsletters(data);
  };

  const onCreate = () => {
    console.log("Create Newsletter clicked");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters({ ...filters, [name]: value });
  };

  const onEdit = (newsletter) => {
    setEditingId(newsletter.id);
    setEditRow({ ...newsletter }); // clone row
  };

  const onCancelEdit = () => {
    setEditingId(null);
    setEditRow({});
  };

  const onEditChange = (e) => {
    const { name, value } = e.target;
    setEditRow((prev) => ({ ...prev, [name]: value }));
  };

  const onSave = async () => {
    try {
      console.log("Saving newsletter:", editRow);

      // 🔁 Replace with your API call
      // await updateNewsletter(editRow.id, editRow);

      setNewsletters((prev) =>
        prev.map((n) => (n.id === editRow.id ? editRow : n))
      );

      setEditingId(null);
      setEditRow({});
    } catch (err) {
      alert("Failed to update newsletter");
    }
  };


  const onDelete = (id) => {
    console.log("Delete newsletter:", id);
  };

  const onSendNewsletter = (region) => {
    console.log("Send newsletter for region:", region);
    // Implement sending newsletter to all subscribers in the specified region
  };

  const onSendTestEmail = (id, mode) => {
    console.log("Send test email for newsletter:", id);
    setEmailMode(mode);
    setSelectedNewsletterId(id);
    setShowEmailModal(true);
  };

  const sendTestNewsletter = async (newsletterId, name, email, message) => {
    try {
      console.log(
        `Sending test newsletter ${newsletterId} to ${email} with message: ${message}`
      );
      // Call your email sending service here
      const formData = newsletters.find((n) => n.id === newsletterId);
      formData.email = email;
      formData.name = name;
      formData.message = message;
      formData.unsubscribeURL = unsubscribeURL + email;
      console.log("Newsletter data to send:", formData);
      if (emailMode === "emailjs") {
        await sendEmail(formData, formData.templateID, "service_retreat");
      } else if (emailMode === "sendgrid") {
        sendEmailNewsLetters(formData);
        // Implement sendGrid email sending logic here
      }
      alert("Test newsletter sent successfully!");
    } catch (error) {
      console.error("Error sending test newsletter:", error);
      alert("Failed to send test newsletter.");
    }
  };

  const btnPrimary = { marginRight: 8, marginBottom: 8 };
  const th = { padding: 12, textAlign: "left", fontWeight: "bold" };
  const td = { padding: 12, borderBottom: "1px solid #ddd" };
  const btn = { padding: "6px 12px", marginRight: 4 };

  return (
    <>
      {/* Header */}
      <div className="container-fluid p-0 d-flex justify-content-between align-items-center">
        <MarianLogo />
        <h5 className="text-center mb-0">Newsletters</h5>
        {user ? (
          <a
            href="/logout"
            className="h6 nav-item nav-link"
            onClick={(e) => {
              e.preventDefault();
              console.log("Logout Menu clicked");
              logout();
            }}
          >
            Logout
          </a>
        ) : (
          <a href="/login" className="nav-item nav-link">
            Login
          </a>
        )}
      </div>
      <div className="container-fluid mt-1 mb-1">
        {/* Filter Section */}
        <div className="filter-panel mb-3">
          <div className="row g-2 align-items-center">
            {/* Search by ID */}
            <div className="col-md-2 col-sm-4">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search by ID"
                name="id"
                value={filters.id}
                onChange={handleChange}
                aria-label="Search by ID"
              />
            </div>

            {/* Search by Date */}
            <div className="col-md-2 col-sm-4">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search by Date"
                name="date"
                value={filters.date}
                onChange={handleChange}
                aria-label="Search by Date"
              />
            </div>

            {/* Search by Region */}
            <div className="col-md-2 col-sm-4">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search by Region"
                name="region"
                value={filters.region}
                onChange={handleChange}
                aria-label="Search by Region"
              />
            </div>

            {/* Search by Category */}
            <div className="col-md-2 col-sm-4">
              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search by Category"
                name="category"
                value={filters.category}
                onChange={handleChange}
                aria-label="Search by Category"
              />
            </div>

            {/* Buttons */}
            <div className="col-md-4 col-sm-8 d-flex flex-wrap align-items-center">
              <button
                onClick={onCreate}
                className="btn btn-secondary btn-sm me-2 mb-2"
              >
                + Create
              </button>
              <button onClick={onList} className="btn btn-primary btn-sm mb-2">
                List
              </button>
            </div>
          </div>
        </div>

        {/* Table */}
        <table width="100%" style={{ borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#f3f3f3" }}>
              <th style={th}>Subject & Content</th>
              <th style={th}>Regions</th>
              <th style={th}>Events</th>
              <th style={th}>Videos</th>
              <th style={th}>Template</th>
              <th style={th}>Actions</th>
            </tr>
          </thead>

          <tbody>
            {newsletters.map((n) => {
              const isEditing = editingId === n.id;

              return (
                <tr key={n.id}>
                  {/* ================= SUBJECT & CONTENT ================= */}
                  <td style={td}>
                    {isEditing ? (
                      <>
                        <input
                          className="form-control form-control-sm mb-2"
                          name="subject"
                          value={editRow.subject || ""}
                          onChange={onEditChange}
                          placeholder="Subject"
                        />

                        <input
                          className="form-control form-control-sm mb-2"
                          name="heading"
                          value={editRow.heading || ""}
                          onChange={onEditChange}
                          placeholder="Heading"
                        />

                        <textarea
                          className="form-control form-control-sm mb-2"
                          name="section1"
                          rows={2}
                          value={editRow.section1 || ""}
                          onChange={onEditChange}
                          placeholder="Section 1"
                        />

                        <textarea
                          className="form-control form-control-sm mb-2"
                          name="section2"
                          rows={2}
                          value={editRow.section2 || ""}
                          onChange={onEditChange}
                          placeholder="Section 2"
                        />

                        <textarea
                          className="form-control form-control-sm"
                          name="blessings"
                          rows={2}
                          value={editRow.blessings || ""}
                          onChange={onEditChange}
                          placeholder="Blessings"
                        />
                      </>
                    ) : (
                      <>
                        <strong>{n.subject}</strong>
                        <div style={{ fontSize: 12, color: "#666" }}>
                          <strong>{n.heading}</strong>
                          {[n.section1, n.section2, n.section3, n.blessings]
                            .filter(Boolean)
                            .map((text, idx) => (
                              <p
                                key={idx}
                                style={{ marginBottom: 6, textIndent: "2em" }}
                              >
                                {text}
                              </p>
                            ))}
                        </div>
                      </>
                    )}
                  </td>

                  {/* ================= REGIONS ================= */}
                  <td style={td}>
                    {isEditing ? (
                      <input
                        className="form-control form-control-sm"
                        name="regions"
                        value={editRow.regions || ""}
                        onChange={onEditChange}
                      />
                    ) : (
                      n.regions
                    )}
                  </td>

                  {/* ================= EVENTS (3) ================= */}
                  <td style={td}>
                    {[1, 2, 3].map((i) => (
                      <div key={i} style={{ marginBottom: 8 }}>
                        {isEditing ? (
                          <>
                            <input
                              className="form-control form-control-sm mb-1"
                              name={`event${i}_name`}
                              value={editRow[`event${i}_name`] || ""}
                              onChange={onEditChange}
                              placeholder={`Event ${i} Name`}
                            />
                            <input
                              className="form-control form-control-sm mb-1"
                              name={`event${i}_dates`}
                              value={editRow[`event${i}_dates`] || ""}
                              onChange={onEditChange}
                              placeholder="Dates"
                            />
                            <input
                              className="form-control form-control-sm"
                              name={`event${i}_url`}
                              value={editRow[`event${i}_url`] || ""}
                              onChange={onEditChange}
                              placeholder="URL"
                            />
                          </>
                        ) : (
                          <>
                            <strong>{n[`event${i}_name`]}</strong>{" "}
                            {n[`event${i}_url`] && (
                              <a
                                href={n[`event${i}_url`]}
                                target="_blank"
                                rel="noreferrer"
                              >
                                (Link)
                              </a>
                            )}
                            <div>{n[`event${i}_dates`]}</div>
                            {i < 3 && <hr />}
                          </>
                        )}
                      </div>
                    ))}
                  </td>

                  {/* ================= VIDEOS (3) ================= */}
                  <td style={td}>
                    {[1, 2, 3].map((i) => (
                      <div key={i} style={{ marginBottom: 8 }}>
                        {isEditing ? (
                          <>
                            <input
                              className="form-control form-control-sm mb-1"
                              name={`video${i}_title`}
                              value={editRow[`video${i}_title`] || ""}
                              onChange={onEditChange}
                              placeholder={`Video ${i} Title`}
                            />
                            <input
                              className="form-control form-control-sm mb-1"
                              name={`video${i}_subtitle`}
                              value={editRow[`video${i}_subtitle`] || ""}
                              onChange={onEditChange}
                              placeholder="Subtitle"
                            />
                            <input
                              className="form-control form-control-sm"
                              name={`video${i}_url`}
                              value={editRow[`video${i}_url`] || ""}
                              onChange={onEditChange}
                              placeholder="URL"
                            />
                          </>
                        ) : (
                          <>
                            {n[`video${i}_title`] && (
                              <>
                                🎥{" "}
                                {n[`video${i}_url`] ? (
                                  <a
                                    href={n[`video${i}_url`]}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    {n[`video${i}_title`]}
                                  </a>
                                ) : (
                                  n[`video${i}_title`]
                                )}
                                <div>{n[`video${i}_subtitle`]}</div>
                                {i < 3 && <hr />}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    ))}
                  </td>

                  {/* ================= TEMPLATE ================= */}
                  <td style={td}>
                    {isEditing ? (
                      <input
                        className="form-control form-control-sm"
                        name="templateID"
                        value={editRow.templateID || ""}
                        onChange={onEditChange}
                      />
                    ) : (
                      n.templateID
                    )}
                  </td>

                  {/* ================= ACTIONS ================= */}
                  <td style={{ ...td, verticalAlign: "middle" }}>
                    {isEditing ? (
                      <div className="d-flex gap-2">
                        <button className="btn btn-success btn-sm" onClick={onSave}>
                          <FaSave />
                        </button>
                        <button
                          className="btn btn-secondary btn-sm"
                          onClick={onCancelEdit}
                        >
                          <FaTimes />
                        </button>
                      </div>
                    ) : (
                      <div className="d-flex gap-2 flex-wrap">
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => onEdit(n)}
                        >
                          <FaEdit />
                        </button>

                        <button
                          className="btn btn-danger btn-sm"
                          onClick={() => onDelete(n.id)}
                        >
                          <FaTrash />
                        </button>

                        <button
                          className="btn btn-warning btn-sm"
                          onClick={() => onSendTestEmail(n.id, "emailjs")}
                        >
                          EmailJS <FaInbox />
                        </button>

                        <button
                          className="btn btn-warning btn-sm"
                          onClick={() => onSendTestEmail(n.id, "sendgrid")}
                        >
                          SendGrid <FaInbox />
                        </button>
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}

            {!newsletters.length && (
              <tr>
                <td colSpan="6" style={{ padding: 16, textAlign: "center" }}>
                  No newsletters found
                </td>
              </tr>
            )}
          </tbody>
        </table>

      </div>
      <SendEmailModal
        title="NEWSLETTER TEST"
        show={showEmailModal}
        handleClose={() => setShowEmailModal(false)}
        handleSend={(name, email, message) =>
          sendTestNewsletter(selectedNewsletterId, name, email, message)
        }
      />
    </>
  );
}
